@if (agreement?.agreementSignatures?.length) {
  <form [formGroup]="form">
    <h1>
      {{
        'invite-signup-process-contract.component.you_already_signed_contract_header'
          | localise: 'You have already signed the contract'
      }}
    </h1>
    <button
      class="p-button p-button--rounded p-button--application-next"
      (click)="inviteSignupProcessService.nextStep()">
      {{
        'invite-signup-process-contract.component.next_button'
          | localise: 'Next'
      }}
    </button>
  </form>
}

@if (!agreement?.agreementSignatures?.length) {
  <form [formGroup]="form">
    <app-agreement-text
      [agreement]="agreement"
      [onlyLightMode]="true"
      [wide]="false"
      [signingAgreement]="true"></app-agreement-text>
    <div class="full-width name-page margin-complete">
      <div class="privacy-policy-block">
        <div class="doc-agreement">
          <mat-checkbox formControlName="privacyPolicy"></mat-checkbox>
          <div>
            {{
              'invite-signup-process-contract.component.reviewed_agree'
                | localise
                  : 'I have reviewed and agree to all terms within the Benefits Platform Pilot Agreement'
            }},
            <a
              class="url url-text main-color"
              target="_blank"
              href="https://www.gettongo.com/privacy-policy/">
              {{
                'invite-signup-process-contract.component.help_and_support'
                  | localise: 'Privacy Policy'
              }}</a
            >
            {{
              'invite-signup-process-contract.component.and' | localise: 'and'
            }}
            <a
              class="url url-text main-color"
              href="https://gettongo.com/electronic-disclosure-and-consent/"
              target="_blank">
              {{
                'invite-signup-process-contract.component.electronic_disclosure'
                  | localise: 'Electronic Disclosure'
              }}</a
            >.
          </div>
        </div>
      </div>
      <div>
        <div class="doc-agreement">
          <mat-checkbox
            class="consent-business"
            formControlName="consentBusiness">
          </mat-checkbox>
          <div>
            {{
              'sign-user-agreement.component.agree_text_1'
                | localise: 'I consent to conduct business using '
            }}
            <u>{{
              'sign-user-agreement.component.app_gettongo_com'
                | localise: 'app.gettongo.com'
            }}</u>
            {{
              'sign-user-agreement.component.agree_text_2'
                | localise: ', to receive any document or communication via '
            }}
            <u>{{
              'sign-user-agreement.component.app_gettongo_com'
                | localise: 'app.gettongo.com'
            }}</u>
            {{
              'sign-user-agreement.component.agree_text_3'
                | localise
                  : ', and to utilize my electronic signature in lieu of signing paper documents.'
            }}
          </div>
        </div>
      </div>
      <div>
        <div class="doc-agreement">
          <mat-checkbox class="remember" formControlName="stripeCeltic">
          </mat-checkbox>
          <div>
            {{
              'invite-signup-process-contract.component.reviewed_agree_all_terms'
                | localise: 'I have reviewed and agree to all terms within the'
            }}
            <a
              target="_blank"
              class="main-color"
              href="https://stripe.com/privacy"
              >Stripe
              {{
                'invite-signup-process-contract.component.help_and_support'
                  | localise: 'Privacy Policy'
              }}</a
            >
            {{
              'invite-signup-process-contract.component.and_the'
                | localise: 'and the'
            }}
            <a
              target="_blank"
              class="main-color"
              href="https://www.celticbank.com/privacy"
              >Celtic Bank
              {{
                'invite-signup-process-contract.component.help_and_support'
                  | localise: 'Privacy Policy'
              }}</a
            >.
          </div>
        </div>
      </div>
      <div>
        <div class="doc-agreement">
          <mat-checkbox class="remember" formControlName="astraTerms">
          </mat-checkbox>
          <div>
            {{
              'agreement-terms.i_reviewed_and_agree_to_all_terms'
                | localise: 'I have reviewed and agree to all terms within the'
            }}
            <a
              href="https://astrafi.com/terms/"
              class="main-color"
              target="_blank">
              {{
                'agreement-terms.astra_terms_service'
                  | localise: 'Astra’s Terms of Service'
              }}
            </a>
            {{ 'agreement-terms.and_the_text' | localise: ' and the ' }}
            <a
              href="https://astrafi.com/privacy/"
              class="main-color"
              target="_blank">
              {{
                'agreement-terms.astra_privacy_policy'
                  | localise: 'Privacy Policy'
              }} </a
            >.
          </div>
        </div>
      </div>
      <div class="actions buttons-agreement">
        <button
          mat-button
          type="submit"
          class="p-button p-button--rounded p-button--application-next"
          [disabled]="form.invalid || loading"
          (click)="next()">
          {{
            'invite-signup-process-contract.component.submit'
              | localise: 'Submit'
          }}
        </button>
      </div>
    </div>
  </form>
}
